export default __webpack_public_path__ + "static/media/gallery_02.67bd7dac.jpg";